/**
 * Ce que disent les écrans d'un défi local (collecteur sur l'ordinateur du titulaire). Rien n'est
 * ouvert : la consigne de l'agent d'abord (extension Chrome à relier, passage demandé par une autre
 * personne qui attend le « C'est parti » du titulaire, connexion à refaire), sinon où se connecter.
 * Une fenêtre n'est promise que hors de l'onglet prêté : un portail de justificatifs ne s'ouvre
 * jamais que dans un onglet du Chrome de tous les jours.
 */
export function textesDefiLocal(d: {
  message: string | null
  libelle: string
  ongletPrete: boolean
  /** L'ordinateur du titulaire, nommé. */
  ou: string
}): { attente: string; ouvert: string } {
  const lieu = d.ongletPrete ? 'un onglet de Chrome' : 'une fenêtre'
  return {
    attente:
      d.message ??
      `Le portail vous attend (${d.libelle}). Installez-vous devant ${d.ou} : ${lieu} s’y ouvrira, connectez-vous vous-même.`,
    ouvert: d.ongletPrete
      ? 'Un onglet de Chrome y est ouvert'
      : 'Une fenêtre du collecteur y est ouverte',
  }
}
